import { TableBody, TableHeader } from '@library/components/table';
import { useCallback, useState } from 'react';
import { Loading } from '@library/components/Loading';
import { PROMOTIONS_HEADER } from '@library/constants/promotions';
import { PaginationButtons } from '@library/components/buttons';
import { PromotionRow } from '@bo-components/promotions/PromotionRow';
import type { PromotionsRequest } from '@library/types/promotions';
import { StyledTable } from '@bo-components/common/StyledTable';
import { useGetPromotionsQuery } from '@bo-services/promotionsApi';

export const PromotionsList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(25);

  const promotionsQueryParams: PromotionsRequest = {
    page: currentPage,
    perPage
  };

  const {
    data: promotions,
    isFetching: isFetchingPromotions,
    error
  } = useGetPromotionsQuery(promotionsQueryParams);

  const handlePageChange = useCallback(
    (newPage: number) => {
      setCurrentPage(newPage);
    },
    [setCurrentPage]
  );

  // TODO: Uncomment and implement after we complete Promotion Creation in HQ Project
  // const handleSort = useCallback(
  //   (sortedPromotionColumn: SortedPromotionsColumn) => {
  //     setSort(sortedPromotionColumn);
  //   },
  //   [setSort]
  // );

  if (isFetchingPromotions) {
    return <Loading loadingMessage="Loading Promotions" />;
  }

  return (
    <>
      <StyledTable
        errorMessage="Error Fetching Promotions"
        isError={!!error}
        noData={!promotions?.data.length}
        noDataMessage={{
          label: 'No promotions found. Try changing your filters.',
          title: 'No Promotions',
          dataTestId: 'no-promotions-results'
        }}
        data-testid="Promotions"
      >
        <TableHeader
          headers={PROMOTIONS_HEADER}
          className="bg-soFresh-110 text-soClean-130 sticky top-0 z-10 flex w-full min-w-[1020px] items-center justify-start text-xs font-bold"
        />
        <TableBody>
          {promotions?.data.map((promotion) => (
            <PromotionRow key={promotion.id} promotion={promotion} />
          ))}
        </TableBody>
      </StyledTable>

      <div className="bg-soFresh-100 sticky bottom-0 flex items-center justify-end gap-4 px-4">
        <PaginationButtons
          currentPage={currentPage}
          handlePageChange={handlePageChange}
          totalPages={promotions?.meta?.total_pages ?? 0}
        />
      </div>
    </>
  );
};
